import React, { useState } from "react";
import Button from "../../FormComponents/Button";
import Input from "../../FormComponents/Input";
import Textarea from "../../FormComponents/Textarea";
import Label from "../../FormComponents/Label";

const RegexTester = ({ defaultValue, onSelect }) => {
  const [pattern, setPattern] = useState(defaultValue);
  const [testString, setTestString] = useState("");
  const [error, setError] = useState("");
  const [matches, setMatches] = useState([]);

  const handlePatternChange = (e) => {
    const newPattern = e.target.value;
    setPattern(newPattern);
    updateMatches(newPattern, testString);
  };

  const handleTestStringChange = (e) => {
    const newString = e.target.value;
    setTestString(newString);
    updateMatches(pattern, newString);
  };

  const updateMatches = (patternInput, str) => {
    try {
      const regex = new RegExp(patternInput, "g");
      const found = [...str.matchAll(regex)].map((match) => match[0]);
      setMatches(found);
      setError("");
    } catch (err) {
      setError("Invalid regex: " + err.message);
      setMatches([]);
    }
  };

  const handleSelectPattern = () => {
    if (!error && onSelect) {
      onSelect(pattern);
    }
  };

  return (
    <div className={"builder_form"}>
      <Button onClick={handleSelectPattern} disabled={!!error}>
        Use This Pattern
      </Button>

      <Input
        type="text"
        label={"Regex Pattern:"}
        value={pattern}
        onChange={handlePatternChange}
        placeholder="e.g. \\d+"
        style={{ width: "100%", padding: "8px", marginBottom: "1rem" }}
      />

      <Textarea
        rows={4}
        value={testString}
        label={"Test String:"}
        onChange={handleTestStringChange}
        placeholder="Type a string to test here..."
      />

      {error ? (
        <p style={{ color: "red" }}>{error}</p>
      ) : (
        <div>
          <Label>Matches:</Label>
          <ul>{matches.length > 0 ? matches.map((m, i) => <li key={i}>{m}</li>) : <li>No matches found</li>}</ul>
        </div>
      )}
    </div>
  );
};
export default RegexTester;
